const DOSEN_ROLES = {
  pembimbing: "pembimbing",
  penguji: "penguji",
};

export default DOSEN_ROLES;
